import React, { useRef } from 'react';

import classNames from 'classnames';
import { uniqueId } from 'lodash';
import Highlight, { defaultProps } from 'prism-react-renderer';

import { getCodeBlockInformation } from '../../../utils/codeBlock';
import { CodeBlockContainer } from '../CodeBlockContainer';
import { CodeBlockLine } from '../CodeBlockLine';
import { CodePre } from '../CodePre';

import { MultiHeader } from './MultiHeader';
import * as classes from './style.module.scss';

interface Props {
  className: string;
}

export const Multi: React.FC<Props> = ({ className, children }) => {
  const uuid = useRef(uniqueId('multi-code-block'));
  const [codeLanguage] = getCodeBlockInformation(className);

  if (typeof children !== 'string') return children as React.ReactElement;

  return (
    <CodeBlockContainer className={classNames(classes.codeoverflow, className)}>
      <MultiHeader />
      <CodePre codeLanguage={codeLanguage}>
        <div className={classes.panel}>
          <Highlight
            {...defaultProps}
            theme={undefined}
            code={children.trimEnd().replace(/\n+$/, '')}
            // note: Language in Highlight does not work with our custom languages we added in Layout.tsx
            language={codeLanguage as any}
          >
            {({ tokens, getLineProps, getTokenProps }) => {
              return tokens.map((line, i) => (
                <CodeBlockLine
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${uuid}-${i}`}
                  index={i}
                  line={line}
                  getLineProps={getLineProps}
                  getTokenProps={getTokenProps}
                />
              ));
            }}
          </Highlight>
        </div>
      </CodePre>
    </CodeBlockContainer>
  );
};
